import { RISK_RULES_TO_SHOW_ON_KRBTGT_LIST } from '@silverfort-nodelibs/common/utils/insight';
import { INVESTIGATION_ENTITY_TYPES, ROLES } from '@silverfort-nodelibs/common/utils/consts';

import { bigNumberToText, isUserPermitted } from '../../../utils';
import { EntitiesPopup, RiskIndicatorsPopup } from '../../../Controls/EntitiesPopup/EntitiesPopup';
import IndicatorBox from '../../../Controls/IndicatorBox/IndicatorBox';
import style from './Boxes.module.css';
import { useState } from 'react';

// TODO
const Boxes = ({ entityData, entityType, user }) => {
    const metrics = entityData.metrics;
    const [popUp, setPopUp] = useState({});

    const isApplication =
        entityType.id === INVESTIGATION_ENTITY_TYPES.APPLICATION.id ||
        entityType.id === INVESTIGATION_ENTITY_TYPES.OKTA.id;
    const boxesProps = [];
    let filteredRiskReasons = entityData.RiskReasons;
    if (
        filteredRiskReasons &&
        entityType.id === INVESTIGATION_ENTITY_TYPES.RESOURCE.id &&
        entityData &&
        entityData.details &&
        entityData.details.display_name === 'krbtgt'
    ) {
        filteredRiskReasons = filteredRiskReasons.filter((riskIndicator) => {
            return RISK_RULES_TO_SHOW_ON_KRBTGT_LIST.includes(riskIndicator.riskRules[0]);
        });
    }
    boxesProps.push({
        count: filteredRiskReasons ? bigNumberToText(filteredRiskReasons.length) : 0,
        name: 'Risk Indicators',
        key: 'Risk Indicators',
        onClick: () =>
            setPopUp({
                ShowRiskEntitiesPopup: true,
                EntitiesPopupData: filteredRiskReasons ? filteredRiskReasons : []
            })
    });
    if (entityType.id !== INVESTIGATION_ENTITY_TYPES.USER.id && metrics) {
        boxesProps.push({
            count: metrics.topUsers ? bigNumberToText(metrics.topUsers.length) : 0,
            name: 'Users',
            key: 'Users',
            onClick: () =>
                setPopUp({
                    ShowEntitiesPopup: true,
                    EntitiesPopupData: metrics.topUsers,
                    EntitiesPopupCountObject: !isApplication,
                    EntitiesPopupNameObject: isApplication,
                    EntitiesPopupApplicationObject: false,
                    extraEntityDetails: null,
                    EntitiesPopupTitle: 'Users'
                })
        });
    }

    if (
        entityType.id !== INVESTIGATION_ENTITY_TYPES.DEVICE.id &&
        entityType.id !== INVESTIGATION_ENTITY_TYPES.OKTA.id &&
        metrics
    ) {
        boxesProps.push({
            count: metrics.topDevices ? bigNumberToText(metrics.topDevices.length) : 0,
            name: 'Sources',
            key: 'Sources',
            onClick: () =>
                setPopUp({
                    ShowEntitiesPopup: true,
                    EntitiesPopupData: metrics.topDevices,
                    EntitiesPopupNameObject: false,
                    EntitiesPopupCountObject: true,
                    EntitiesPopupApplicationObject: false,
                    extraEntityDetails: null,
                    EntitiesPopupTitle: 'Sources'
                })
        });
    }

    if (entityType.id === INVESTIGATION_ENTITY_TYPES.USER.id && metrics) {
        boxesProps.push({
            count: metrics.topResources ? bigNumberToText(metrics.topResources.length) : 0,
            name: 'Destinations',
            key: 'Destinations',
            onClick: () =>
                setPopUp({
                    ShowEntitiesPopup: true,
                    EntitiesPopupData: metrics.topResources,
                    EntitiesPopupNameObject: false,
                    EntitiesPopupCountObject: true,
                    EntitiesPopupApplicationObject: false,
                    extraEntityDetails: null,
                    EntitiesPopupTitle: 'Destination'
                })
        });
    }

    if (entityType.id !== INVESTIGATION_ENTITY_TYPES.DEVICE.id) {
        boxesProps.push({
            count: entityData.rules ? bigNumberToText(entityData.rules.length) : 0,
            name: 'Active Policies',
            key: 'Active Policies',
            onClick: () =>
                setPopUp({
                    ShowEntitiesPopup: true,
                    EntitiesPopupData: entityData.rules,
                    EntitiesPopupNameObject: true,
                    EntitiesPopupCountObject: false,
                    EntitiesPopupApplicationObject: false,
                    extraEntityDetails: null,
                    EntitiesPopupTitle: 'Active Policies',
                    jumpToPolicy: isUserPermitted(user, 'policies', ROLES.VIEWER.value)
                })
        });
    }
    if (entityType.id === INVESTIGATION_ENTITY_TYPES.USER.id) {
        boxesProps.push({
            count: entityData.applications ? bigNumberToText(entityData.applications.length) : 0,
            name: 'Cloud Applications',
            key: 'Cloud Applications',
            onClick: () =>
                setPopUp({
                    ShowEntitiesPopup: true,
                    EntitiesPopupData: entityData.applications,
                    EntitiesPopupNameObject: true,
                    EntitiesPopupCountObject: false,
                    EntitiesPopupApplicationObject: true,
                    extraEntityDetails: null,
                    EntitiesPopupTitle: 'Cloud Applications'
                })
        });
        boxesProps.push({
            count: entityData.azureRoles ? bigNumberToText(entityData.azureRoles.length) : 0,
            name: 'Entra ID Roles',
            key: 'AAD Roles',
            onClick: () =>
                setPopUp({
                    ShowEntitiesPopup: true,
                    EntitiesPopupData: entityData.azureRoles,
                    EntitiesPopupNameObject: true,
                    EntitiesPopupCountObject: false,
                    EntitiesPopupApplicationObject: false,
                    extraEntityDetails: [
                        {
                            moreDetailsKey: 'description',
                            moreDetailsHeader: 'Description'
                        },
                        {
                            moreDetailsKey: 'type',
                            moreDetailsHeader: 'Type'
                        }
                    ],
                    EntitiesPopupTitle: 'Entra ID Roles'
                })
        });
    }

    return (
        <>
            <div className={style.warper}>
                {boxesProps.map((props) => (
                    <div key={props.key} className={style.box}>
                        <IndicatorBox {...props} />
                    </div>
                ))}
            </div>
            {popUp.ShowEntitiesPopup && (
                <EntitiesPopup
                    user={user}
                    title={popUp.EntitiesPopupTitle}
                    data={popUp.EntitiesPopupData}
                    onHide={() => setPopUp({ ShowEntitiesPopup: false })}
                    show={popUp.ShowEntitiesPopup}
                    isCountObject={popUp.EntitiesPopupCountObject}
                    isNameObject={popUp.EntitiesPopupNameObject}
                    isApplicationObject={popUp.EntitiesPopupApplicationObject}
                    extraEntityDetails={popUp.extraEntityDetails}
                    jumpToPolicy={popUp.jumpToPolicy}
                />
            )}
            {popUp.ShowRiskEntitiesPopup && (
                <RiskIndicatorsPopup
                    data={popUp.EntitiesPopupData}
                    onHide={() => setPopUp({ ShowRiskEntitiesPopup: false })}
                    show={popUp.ShowRiskEntitiesPopup}
                    isCountObject={true}
                />
            )}
        </>
    );
};

export default Boxes;
